import n from "react";
import o from "@mui/material/TextField";
function p({
  value: e,
  onChange: t,
  onBlur: r,
  maxLength: i,
  rows: u = 3,
  ...a
}) {
  return /* @__PURE__ */ n.createElement(
    o,
    {
      ...a,
      value: e || "",
      multiline: !0,
      rows: u,
      variant: "outlined",
      onChange: t,
      onBlur: r,
      inputProps: {
        maxLength: i
      }
    }
  );
}
export {
  p as T
};
